import { useRedirect } from "../../hooks/useRedirect";
import { validateEmail } from "lib/forms";
import React, { useDispatch, useEffect, useGlobal, useState } from "reactn";
import config from "config";
import format, { validate, validatePhone } from "lib/rut";

const { loginURL, stagingloginURL, labLoginURL } = config;

const loginDinamicUrl =
	window && window.location.hostname === "staging.zeroq.cl"
		? stagingloginURL
		: window && window.location.hostname === "lab.zeroq.cl"
		? labLoginURL
		: loginURL;

export const useUpdateUserInfo = () => {
	const updateUserData = useDispatch("updateUserData");
	const resetUserUpdate = useDispatch("resetUserUpdate");
	const [user] = useGlobal("user");
	const { isLoading, error, resolved } = user;

	useEffect(() => () => resetUserUpdate(), [resetUserUpdate]);

	return [updateUserData, isLoading, error, resolved];
};

// !DEPRECATED, use useUpdateUserInfo instead
export const useUpdateUser = () => {
	const registerRut = useDispatch("registerRut");
	const registerDni = useDispatch("registerDni");

	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [resolved, setResolved] = useState(false);

	const updateUser = ({ type, rut, dni, whatsapp, phone }) => {
		if (loading) return;
		setError(null);
		if (type === "rut" && !validate(format(rut))) {
			setError("RUT inválido");
			return;
		}
		if (type === "dni" && !dni) {
			setError("DNI inválido");
			return;
		}
		if (whatsapp === true && !validatePhone(phone)) {
			setError("Número de teléfono inválido");
			return;
		}
		setLoading(true);
		const fn = type === "rut" ? registerRut : registerDni;
		fn(type === "rut" ? rut : dni)
			.then(() => {
				setLoading(false);
				setResolved(true);
			})
			.catch((e) => setError(e));
	};

	return [updateUser, loading, error, resolved];
};

export const useLoginWithPassword = () => {
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);
	const doLoginWithPass = useDispatch("doLoginWithPass");

	const { redirectToPreviousRoute, redirectToHome } = useRedirect();

	const logIn = ({ email, password }) => {
		setError(null);
		if (!validateEmail(email)) {
			setError({ message: "E-mail inválido" });
			return;
		}
		if (!password) {
			setError({ message: "Password inválido" });
			return;
		}
		setLoading(true);
		doLoginWithPass({ email, password })
			.then(() => {
				setSuccess(true);
				setLoading(false);
				redirectToHome();
			})
			.catch((debug) => {
				if (debug.message === "INVALID_PASSWORD") {
					setError({
						message:
							"Por favor verifique sus datos, si el problema persiste, intente recuperar su contraseña o registrarse.",
						debug,
					});
					setLoading(false);
					return;
				}
				if (debug.message === "no rows in result set") {
					setError({
						message:
							"Por favor verifique sus datos, si el problema persiste, intente recuperar su contraseña o registrarse.",
						debug,
					});
					setLoading(false);
					return;
				}
				if (debug.message === "stale-password") {
					setError({
						message:
							"Por favor verifique sus datos, si el problema persiste, intente recuperar su contraseña o registrarse.",
						debug,
					});
					setLoading(false);
					return;
				}
				if (
					debug.message ===
					"TOO_MANY_ATTEMPTS_TRY_LATER : Access to this account has been temporarily disabled due to many failed login attempts. You can immediately restore it by resetting your password or you can try again later."
				) {
					setError({
						message:
							"Por favor verifique sus datos, si el problema persiste, intente recuperar su contraseña o registrarse.",
						debug,
					});
					setLoading(false);
					return;
				}
				setError({
					message:
						"Por favor verifique sus datos, si el problema persiste, intente recuperar su contraseña o registrarse.",
					debug,
				});
				setLoading(false);
			});
	};

	return [logIn, success, loading, error];
};

export const useLoginWithProvider = () => {
	const [error, setError] = useState(null);
	const [loadingM, setLoadingM] = useState(false);
	const [loadingG, setLoadingG] = useState(false);
	const [loadingF, setLoadingF] = useState(false);
	const [success, setSuccess] = useState(false);

	const doLoginWithProvider = useDispatch("doLoginWithProvider");

	const { redirectToPreviousRoute } = useRedirect();

	const logIn = (provider) => () => {
		provider === "google" && setLoadingG(true);
		provider === "facebook" && setLoadingF(true);
		provider === "microsoft" && setLoadingM(true);

		doLoginWithProvider(provider)
			.then(() => {
				setSuccess(true);
				provider === "google" && setLoadingG(false);
				provider === "facebook" && setLoadingF(false);
				provider === "microsoft" && setLoadingM(false);
				redirectToPreviousRoute();
			})
			.catch((err) => {
				provider === "google" && setLoadingG(false);
				provider === "facebook" && setLoadingF(false);
				provider === "microsoft" && setLoadingM(false);
				setError(errToMessage(err));
			});
	};

	return [logIn, success, loadingG, error, loadingF, loadingM];
};

const errToMessage = (err) => {
	const message =
		"Error de autentificación, por favor actualice la página o intente más tarde.";
	if (err && err.code === "auth/popup-closed-by-user")
		return {
			message:
				"Hemos detectado que cerro la ventana emergente, por favor intentelo nuevamente o actualice la página.",
			debug: err,
		};
	if (err && err.code === "auth/account-exists-with-different-credential")
		return {
			message:
				"El correo que usas para acceder a esta cuenta ya está registrado en ZeroQ",
			debug: err,
		};
	if (!err && !err.code) return { message, debug: err };

	return { message, debug: err };
};

export const useUpdatePassword = (code) => {
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	const [success, setSuccess] = useState(false);

	const updatePassword = ({ password0, password1 }) => {
		if (password0 !== password1) {
			setError({ message: "Las contraseñas no coinciden" });
			return;
		}
		window
			.fetch(`${loginDinamicUrl}/password`, {
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ code, password: password0 }),
			})
			.catch((e) => {
				setLoading(false);
				setError({
					message: "Error de red. Verifica tu conexión",
					debug: e,
				});
			})
			.then((res) => {
				if (res.status !== 200) {
					const data = res.json();

					if (data !== "OK" && data.message) {
						setError({
							message: "Ocurrio un error, intente nuevamente",
						});
						throw new Error(data);
					}
					return data;
				}
				return res.json();
			})
			.then((res) => {
				if (res.message) {
					setLoading(false);
					setError({
						message: passwordUpdateErrors(res.message),
						debug: res,
					});
					return;
				}
				if (res.msg && res.msg === "ok") {
					setSuccess(true);
					setLoading(false);
					return;
				}
				throw new Error(res);
			})
			.catch((err) => {
				setLoading(false);
				setError({
					message: passwordUpdateErrors(err.message),
					debug: err,
				});
			});
	};

	return [updatePassword, loading, success, error];
};

const passwordUpdateErrors = (err) => {
	switch (err) {
		case "auth/invalid-action-code":
			return "el código enviado a tu correo es inválido. Por favor, realiza una nueva solicitud.";
		case "INVALID_OOB_CODE":
			return "El link que esta usando actualmente ya fue usado o caduco, por favor solicite recuperar su contraseña nuevamente.";
		case "OPERATION_NOT_ALLOWED":
			return "Este servicio no esta disponible en este momento, por favor intente más tarde.";
		case "EXPIRED_OOB_CODE":
			return "El link que esta usando ha caduco, por favor solicite recuperar su contraseña nuevamente.";
		case "not-matching-passwords":
			return "ambas contraseñas deben coincidir.";
		case "auth/expired-action-code":
			return "el tiempo para recuperar tu contraseña ha expirado. Por favor, realiza una nueva solicitud.";
		case "network/failure":
			return "ha ocurrido un error de red. Verifica tu conexión a Internet.";
		default:
			return "ha ocurrido un error no identificado. Por favor, realiza una nueva solicitud.";
	}
};
